const SensitivePage = () => {
  return (
    <div className="terms-container">
      <b>개인(민감)정보 수집 및 이용 및 제3자 제공 동의</b>
      <p>
        렉스 소프트㈜는 건강성적표 서비스(건강 검진 결과를 보관, 조회 및
        활용하고 생활 습관 및 통증 기록 기반 맞춤형 건강 정보 및 증진 서비스)
        이용을 위하여 아래와 같이 개인정보를 수집·이용하고 제3자에게 제공하고자
        합니다. 아래 내용을 읽으신 후 동의 여부를 결정하실 수 있습니다.
      </p>
      <b>1. 개인정보 수집·이용</b>
      <table style={{ textAlign: "center", display: "table" }}>
        <tr>
          <td style={{ width: "33.3%" }}>수집·이용 항목</td>
          <td style={{ width: "33.3%" }}>수집·이용 목적</td>
          <td style={{ width: "33%" }}>보유·이용 기간</td>
        </tr>
        <tr>
          <td>성명, 전화번호</td>
          <td>건강성적표 서비스 제공</td>
          <td>
            건강성적표 서비스
            <br />
            탈퇴(해지) 시까지
          </td>
        </tr>
      </table>
      <p>
        *위 개인정보 수집·이용 동의를 거부할 권리가 있습니다. 그러나 동의를
        거부하실 경우에는 본 서비스 이용에 제한을 받을 수 있습니다
      </p>
      <b>2. 민감정보 수집·이용</b>
      <table style={{ textAlign: "center", display: "table" }}>
        <tr>
          <td style={{ width: "33.3%" }}>수집·이용 항목</td>
          <td style={{ width: "33.3%" }}>수집·이용 목적</td>
          <td style={{ width: "33%" }}>보유·이용 기간</td>
        </tr>
        <tr>
          <td>
            국가검진·진료 데이터(건강건진 결과, 진료 및 투약 정보, 예방접종
            정보)
          </td>
          <td>건강성적표 서비스 제공</td>
          <td>
            건강성적표 서비스
            <br />
            탈퇴(해지) 시까지
          </td>
        </tr>
      </table>
      <p>
        *위 민감정보 수집·이용 동의를 거부할 권리가 있습니다. 그러나 동의를
        거부하실 경우에는 본 서비스 이용에 제한을 받을 수 있습니다.
      </p>
      <b>3. 민감정보 제3자 제공</b>
      <table style={{ textAlign: "center", display: "table" }}>
        <tr>
          <td style={{ width: "25%" }}>제공받는 자</td>
          <td style={{ width: "25%" }}>제공 목적</td>
          <td style={{ width: "25%" }}>제공 항목</td>
          <td style={{ width: "25%" }}>보유·이용 기간</td>
        </tr>
        <tr>
          <td>대상웰라이프㈜</td>
          <td>건강나이 조회 서비스 제공</td>
          <td>
            국가검진·진료 데이터(건강건진 결과, 진료 및 투약 정보, 예방접종
            정보)
          </td>
          <td>
            건강나이 조회 서비스
            <br />
            탈퇴(해지) 시까지
          </td>
        </tr>
      </table>
      <p>
        *위 민감정보 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를
        거부하실 경우에는 건강나이 조회 서비스 이용에 제한을 받을 수 있습니다
      </p>
    </div>
  );
};

export default SensitivePage;
